import {Button, Card, CardContent} from 'alm-react-components';
import {useTranslation} from 'react-i18next';
import useDailyReminderHook from '../../hooks/useDailyReminderHook';
import {useNavigate} from 'react-router-dom';
import {useEffect, useRef, useState} from 'react';
import { APPROUTES } from '../../assets/constants/constants';
import remindersIconImg from "../../assets/images/svgicons/reminders-icon.svg";

const DailyReminder = () => {
  const {dailyReminderData} = useDailyReminderHook();
  const [textToCopy, setTextToCopy] = useState(''); 
  const h2Ref = useRef<any>(null);
  const {t} = useTranslation();
  const navigate = useNavigate();
  useEffect(() => {
    if (dailyReminderData) {
      setTextToCopy(
        dailyReminderData[0]?.description
          ? dailyReminderData[0]?.description
          : t("MyStance.dailyReminder")
      );
    }
  }, [dailyReminderData]);
  return (
    <>
    <div className="w-[100%] mx-auto xl:px-32 lg:px-8 md:px-8 px-5 py-6 md:py-14 flex-grow">
      <div className="flex flex-wrap justify-between md:flex-nowrap pb-10 md:pb-0">
        <div className="min-w-0 flex-1 md:pb-4 lg:pb-12">
          <h1 className="scroll-m-20 tracking-tight leading-7 text-2xl lg:text-3xl xl:text-4xl font-barlowLight font-light">
            {t('Common.dailyReminder')}
          </h1>
        </div>
        {dailyReminderData && (
          <div className="flex lg:ml-4 md:pb-6 lg:pb-12">
            <Button
              onClick={() => navigate('/daily-reminders',{state:{from: APPROUTES.home}})}
              variant="secondary"
              className="text-base font-normal px-6 py-1 h-9 dark:bg-fillMidGrayCard"
            >
              {t('Common.seeAll')}
            </Button>
          </div>
        )}
      </div>

      <Card className="dark:card-gradient-gray dark:text-white dark:border-0 rounded-2xl">
        <CardContent className="grid p-4 md:py-10 md:px-8">
          <div className=" justify-center flex pb-4">
            <img src={remindersIconImg} alt={" "} className="logo text-sm w-[23px] h-[18px]" />
          </div>
          <div className="flex items-center text-center mx-auto ">
            <h2
              ref={h2Ref}
              className="scroll-m-20 text-2xl font-barlowLight font-light lg:text-[40px] text-primary leading-tight select-none"
            >
              {textToCopy}
            </h2>
          </div>
          <div className="flex items-center justify-end">
            <div className="flex-shrink-0 inline-flex items-center text-base font-opensansSemiBold text-gray-900 dark:text-white">
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
    </>
  );
};
export default DailyReminder;
